
import FloorWrapper from "./FloorWrapper"
import Navigate from "./controls/components/Navigate"
import WareRcmd from "./controls/components/WareRcmd"
import ImageArea from "./controls/components/ImageArea"
import RichText from "./controls/components/RichText"

export default {
  name: "DshopRender",
  components: {
    FloorWrapper,
    Navigate,
    WareRcmd,
    ImageArea,
    RichText
  },
  props: {
    renderData: {
      type: Object,
      required: true
    }
  },
  computed: {
    moduleList() {
      return this.renderData?.moduleList || []
    }
  },
  mounted() {}
}
